import { ChangeDetectorRef, Component, forwardRef, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-tin-input',
  templateUrl: './tin-input.component.html',
  standalone: false,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => TINInputComponent),
      multi: true
    }
  ]
})
export class TINInputComponent implements ControlValueAccessor {
  @Input() value: any;
  @Input() disabled = false;
  @Input() maxLength: string | number | null = 11;
  @Input() borderless = false;
  @Input() ignoreZero = false;
  @Input() allowEdit = true;
  @Input() country: string = 'PH';
  // private _country: number | null = 0;
  // get country(): number | null {
  //   return this._country;
  // }
  // @Input() set country(value: number | null) {
  //     this._country = value;
  // }

  get readonly() {
    if (this.disabled || !this.allowEdit) {
      return true;
    }
    return false;
  }

  onChange: any = () => {};
  onTouched: any = () => {};

  constructor(private cdr: ChangeDetectorRef) {}

  writeValue(value: number): void {
    this.value = value;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  onModelChange(val: any) {
    if (val && this.country === 'PH') this.value = formatTIN(val);
    else this.value = '';
    this.onChange(val);
    this.cdr.markForCheck();
  }

  onKeydown(event: any) {
    if (event.ctrlKey || event.metaKey) return;

    const key = `${event.key}`;
    if (key.length !== 1) return;

    const allow = key >= '0' && key <= '9';
    if (!allow) {
      event.preventDefault();
    }
  }

  onKeyUp(event: any) {
    const input =
      this.country === 'PH'
        ? formatTIN(event.target.value)
        : event.target.value;

    event.target.value = input;
    return false;
  }

  onPaste(event: any) {
    const clipData = event.clipboardData?.getData('text');

    if (clipData) {
      const alphaRegex = /^[0-9-]+/;
      let txtFinal = clipData.replace(alphaRegex, '');
      var isInvalid = alphaRegex.test(txtFinal);
      if (isInvalid) event.preventDefault();
    } else {
      event.preventDefault();
    }
  }

  onClick(e: any) {
    if (!window.getSelection()?.toString()) {
      e.select();
    }
  }
}

export function formatTIN(input: string) {
  let result = '';

  let digitCount = 0;
    for (let c of input) {
    if (c >= '0' && c <= '9') {
      digitCount++;
      result += c;
      if (digitCount === 9) return result;
      else if (digitCount % 3 === 0) {
        result += '-';
      }
    }
  }
  
  return result;
}
